/**
 *  @class
 *  @function VariantPillsMpv2
 *  Product information (v2): option buttons → variant. Updates the product forms, URL, gallery slide,
 *  price, installments and add-to-cart state. Add to cart itself is Vision's <product-form> (product.js).
 */
if (!customElements.get('variant-pills-mpv2')) {
  class VariantPillsMpv2 extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      const json = this.querySelector('script[type="application/json"]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.addEventListener('change', this.onChange.bind(this));
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    onChange() {
      const options = this.selectedOptions();
      options.forEach((value, index) => {
        const label = this.querySelector(`[data-option-value="${index}"]`);
        if (label) label.textContent = value;
      });

      const variant = this.variants.find((v) => v.options.every((value, index) => value === options[index]));
      const button = document.querySelector(`#product-form-${this.sectionId} .single-add-to-cart-button`);
      if (!variant) {
        if (button) {
          button.disabled = true;
          const label = button.querySelector('.single-add-to-cart-button--text');
          if (label && window.theme?.variantStrings) label.textContent = window.theme.variantStrings.unavailable;
        }
        return;
      }

      document
        .querySelectorAll(`#product-form-${this.sectionId} [name="id"], #product-form-installment-${this.sectionId} [name="id"]`)
        .forEach((field) => {
          field.value = variant.id;
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });

      if (this.dataset.updateUrl === 'true') {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${variant.id}`);
      }
      if (variant.featured_media) this.selectMedia(variant.featured_media.id);
      this.renderVariant(variant.id);
    }

    selectMedia(mediaId) {
      const slider = document.querySelector(`#MediaGallery-${this.sectionId} product-slider`);
      const selector = `#Slide-${this.sectionId}-${mediaId}`;
      if (slider && slider.querySelector(selector) && typeof slider.selectCell === 'function') {
        slider.selectCell(selector);
      }
    }

    renderVariant(variantId) {
      fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          [`price-${this.sectionId}`, `price-${this.sectionId}--sticky`, `installments-${this.sectionId}`].forEach((id) => {
            const source = html.getElementById(id);
            const destination = document.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });

          const sourceButton = html.querySelector(`#product-form-${this.sectionId} .single-add-to-cart-button`);
          const button = document.querySelector(`#product-form-${this.sectionId} .single-add-to-cart-button`);
          if (sourceButton && button) {
            button.disabled = sourceButton.disabled;
            button.classList.toggle('sold-out', sourceButton.classList.contains('sold-out'));
            const label = button.querySelector('.single-add-to-cart-button--text');
            const sourceLabel = sourceButton.querySelector('.single-add-to-cart-button--text');
            if (label && sourceLabel) label.textContent = sourceLabel.textContent;
          }
        })
        .catch((error) => console.error(error));
    }
  }
  customElements.define('variant-pills-mpv2', VariantPillsMpv2);
}
